import React from 'react';

import { AccountDisplayProps } from '../AccountPanel';
import { useAuth } from '@/providers/AuthProvider';
import { useTeam } from '@/providers/TeamProvider';
import { ChurchProfile } from './ChurchProfile';

export const SettingChurchProfile: React.FC<AccountDisplayProps> = ({
	popDisplayState,
}) => {
	const { user } = useAuth();
	const { team } = useTeam();
	const isAdmin =
		team.members.find((m) => m.user.id === user.id)?.roles.includes('teamAdmin') ?? false;

	return <ChurchProfile onSave={popDisplayState} readOnly={!isAdmin} />;
};
